// CTA.js
import { useState, useEffect } from "react";
import "../styles/Modal.css";

export default function CTA() {
  const [showModal, setShowModal] = useState(false);

  const openBookingModal = () => {
    setShowModal(true);
    // Add class to body to prevent scrolling
    document.body.classList.add("modal-open");
  };

  const closeBookingModal = () => {
    setShowModal(false);
    // Remove class from body
    document.body.classList.remove("modal-open");
  };

  // Close modal with Escape key
  useEffect(() => {
    const handleEscKey = (event) => {
      if (event.key === 'Escape') {
        closeBookingModal();
      }
    };

    if (showModal) {
      document.addEventListener('keydown', handleEscKey);
    }

    return () => {
      document.removeEventListener('keydown', handleEscKey);
    };
  }, [showModal]);

  // Close modal when clicking outside
  const handleOverlayClick = (e) => {
    if (e.target.classList.contains('modal-overlay')) {
      closeBookingModal();
    }
  };

  return (
    <>
      <section className="cta" id="contact">
        <div className="container">
          <h2>Ready to Transform Your Digital Presence?</h2>
          <p>Get a free consultation and customized quote for your business.</p>

          <button className="btn btn-accent" onClick={openBookingModal}>
            Schedule Consultation!
          </button>
        </div>
      </section>

      {/* Modal - Make sure it's outside the cta section */}
      {showModal && (
        <div 
          className="modal-overlay" 
          onClick={handleOverlayClick}
        >
          <div className="modal-container">
            <button className="modal-close" onClick={closeBookingModal}>
              ×
            </button>
            <div className="modal-content">
              <div className="modal-header">
                <h3>Book Your Free Consultation</h3>
                <p>Select a time that works for you! <br/> <b>The timing mentioned below are according to <i>Indian Standard Time</i>&nbsp;i.e. <i>Asia/Kolkata Zone</i></b></p>
              </div>
              
              {/* Cal.com Embed */}
              {/* REPLACE "YOUR_USERNAME" with your actual Cal.com username */}
              <iframe
                src="https://cal.com/ideas-on-work-4aesdy/15min"
                title="Schedule a Consultation"
                className="cal-iframe"
                frameBorder="0"
                allow="camera; microphone; fullscreen; autoplay"
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
}